import AccountPageContainer from './AccountPage';

export default AccountPageContainer;
